import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=0e504b5e&scoped=true"
import script from "./SettingsModal.vue?vue&type=script&lang=js"
export * from "./SettingsModal.vue?vue&type=script&lang=js"
import style0 from "./SettingsModal.vue?vue&type=style&index=0&id=0e504b5e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e504b5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e504b5e')) {
      api.createRecord('0e504b5e', component.options)
    } else {
      api.reload('0e504b5e', component.options)
    }
    module.hot.accept("./SettingsModal.vue?vue&type=template&id=0e504b5e&scoped=true", function () {
      api.rerender('0e504b5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/settings-modal/SettingsModal.vue"
export default component.exports